module.exports = __webpack_public_path__ + "img/wallet.f9dd531.svg";